import React from 'react'
import { AppBar, Toolbar, Grid } from '@material-ui/core'
import { MenuButton, TitleBar } from 'components/Parts'
import useStyles from './style'

const Navigation = () => {
  const classes = useStyles()
  return (
    <>
      <AppBar position="fixed" className={classes.bar}>
        <Toolbar>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <MenuButton />
            </Grid>
            <TitleBar />
          </Grid>
        </Toolbar>
      </AppBar>
      <div className={classes.offset} />
    </>
  )
}

export default Navigation
